export default function($q, $rootScope, $timeout) {
	let reqsTotal = 0;
	let reqsCompleted = 0;
	const interceptor = {
		request: request,
		response: response,
		responseError: responseError
	};

	return interceptor;

	/*
	 * Public Methods
	 */
	function request(config) {
		if (!config.ignoreLoadingIndicator) {
			if (reqsTotal == 0) {
				$rootScope.$broadcast('wco-loading-indicator:show', {url: config.url});

				$timeout(() => {
					$rootScope.$broadcast('wco-loading-indicator:hide', {url: config.url});
				}, 15000);
			}
			reqsTotal++;
		}
		return config;
	}
	
	function response(response) {
		if (!response || !response.config) {
			return response;
		}

		if (!response.config.ignoreLoadingIndicator) {
			reqsCompleted++;

			if (reqsCompleted >= reqsTotal) {
				reqsCompleted = 0;
				reqsTotal = 0;
				$timeout(() => {
					$rootScope.$broadcast('wco-loading-indicator:hide', {url: response.config.url});
				}, 700);
			}
		}
		return response;
	}

	function responseError(rejection) {	
		if (!rejection || !rejection.config) {
			return rejection;
		}

		if (!rejection.config.ignoreLoadingIndicator) {
			reqsCompleted++;
			if (reqsCompleted >= reqsTotal) {
				reqsCompleted = 0;
				reqsTotal = 0;
				$timeout(() => {
					$rootScope.$broadcast('wco-loading-indicator:hide', {url: rejection.config.url});
				}, 700);
			}
		}
		return $q.reject(rejection);
	}
}
